import { DataTable } from "@/components/DataTable";
import { TableWrapper } from "@/components/TableWrapper";
import { getSosEntityLineItemHashId } from "@/components/SosEntityLineItemHashLink";
import { withJobTrackingData } from "../withJobTrackingData";
import { workOrdersTableColumns, WorkOrderTableRow } from "./work-order-table-columns";

export const WorkOrders = withJobTrackingData(({ workOrders }) => {
  // Flatten the list of work orders into a list of table rows (one row for each line item)
  const data = workOrders.flatMap((wo) =>
    wo.jobLines.map<WorkOrderTableRow>((line, index) => ({
      rowId: getSosEntityLineItemHashId("workorder", wo.id, index),
      wo,
      line,
    })),
  );

  return (
    <TableWrapper className="col">
      <DataTable
        bordered
        hover
        data={data}
        columns={workOrdersTableColumns}
        getRowId={({ rowId }) => rowId}
        initialState={{
          sorting: [{ id: "wo_date", desc: true }],
        }}
      />
    </TableWrapper>
  );
});
